import React from 'react';
import {createRoot} from 'react-dom/client';
import JshModule from '@core/scripts/helper/jsh-module';
import RecommendationSliderDeSy from "../../components/RecommendationSliderDeSy.jsx";

// Initialize all instances on the page
const elements = document.querySelectorAll('[jsh-module="personalization/recommendations-desy"]');

elements.forEach((el) => {
    const {moduleScope, config} = JshModule('personalization/recommendations-desy', el);
    if (!moduleScope) {
        return;
    }

    const {pageViewId, ajaxSwiperData, max_width, displayMode, pinnedOrderNumber, pinnedDigistyleId, contentfulTitle, titleAlignment} = config;
    const {paramString, dataUrl} = ajaxSwiperData;

    let paramStringWithDisplayMode = paramString;
    if (displayMode && displayMode !== 'normal') {
        if (!paramString || paramString === '?') {
            paramStringWithDisplayMode = `?displayMode=${displayMode}`;
        } else if (paramString.includes('displayMode=')) {
            paramStringWithDisplayMode = paramString;
        } else {
            paramStringWithDisplayMode = `${paramString}&displayMode=${displayMode}`;
        }
    }

    let paramStringWithPinnedOrderNumber = paramStringWithDisplayMode;
    if (pinnedOrderNumber) {
        if (!paramStringWithPinnedOrderNumber || paramStringWithPinnedOrderNumber === '?') {
            paramStringWithPinnedOrderNumber = `?pinnedOrderNumber=${pinnedOrderNumber}`;
        } else {
            paramStringWithPinnedOrderNumber = `${paramStringWithPinnedOrderNumber}&pinnedOrderNumber=${pinnedOrderNumber}`;
        }
    }

    let paramStringWithExcludedDigistyleIds = paramStringWithPinnedOrderNumber;
    if (pinnedDigistyleId) {
        if (!paramStringWithExcludedDigistyleIds || paramStringWithExcludedDigistyleIds === '?') {
            paramStringWithExcludedDigistyleIds = `?excludedDigistyleIds=${pinnedDigistyleId}`;
        } else {
            paramStringWithExcludedDigistyleIds = `${paramStringWithExcludedDigistyleIds}&excludedDigistyleIds=${pinnedDigistyleId}`;
        }
    }

    const paramStringWithPageViewId = pageViewId ? paramStringWithExcludedDigistyleIds + '&pageViewId=' + pageViewId : paramStringWithExcludedDigistyleIds;

    // TODO: Get translation or something
    const productCardTexts = {
        pc_color_descriptor: "Farbe",
        pc_size_descriptor: "Größe",
        pc_please_select: "Auswählen",
        pc_variant: "Variante",
        pc_soldout: "Ausverkauft"
    }

    createRoot(moduleScope).render(
        <>
            <RecommendationSliderDeSy
                dataUrl={dataUrl}
                paramString={paramStringWithPageViewId}
                productCardTexts={productCardTexts}
                max_width={max_width}
                contentfulTitle={contentfulTitle}
                titleAlignment={titleAlignment}
            ></RecommendationSliderDeSy>
        </>
    );
});
